import React from 'react'
import { StyleSheet } from 'react-native'

import { B2, B5, H5, SH1, Stack, XStack, colors } from '@zet/design-system'
import { currencyFormatConvertor } from '@zet/utils/stringConversion'

import { Seperator, ZetCoinFilled } from '../../../assets'
import { CoinsSummary } from '../../../types'
import { currencyFormatConvertorRoundDown } from '../../../utils'
import { i18n } from '../../localization'

type CoinsLedgerSpotlightProps = {
  coinsSummary: CoinsSummary
}

const CoinsLedgerSpotlight = ({ coinsSummary }: CoinsLedgerSpotlightProps) => {
  return (
    <Stack
      className="border-grays-40 mx-3 mb-3 items-center justify-center rounded-xl border"
      style={styles.cardContainer}
    >
      <Stack
        className="border-grays-40 w-full items-center justify-center rounded-t-xl border-b pb-3"
        style={styles.cardSubContainer}
      >
        <ZetCoinFilled width={80} height={80} style={styles.zetCoinIcon} />
        <B5 className="text-grays-60">
          {i18n.t('coinsLedger.homeScreen.totalZETCoins')}
        </B5>
        <H5 className="text-grays-80">
          {currencyFormatConvertor(coinsSummary?.total?.toFixed(0) || '00')}
        </H5>
      </Stack>
      <XStack className="flex w-full items-center justify-between rounded-b-xl bg-white pb-3 pt-2">
        <Stack className="flex-1 items-center self-center">
          <B2 className="text-grays-80">
            {i18n.t('coinsLedger.homeScreen.used')}
          </B2>
          <SH1 style={styles.redeemedTextColor}>
            {currencyFormatConvertorRoundDown(
              coinsSummary?.redeemed?.toFixed(0) || '00'
            )}
          </SH1>
        </Stack>
        <Seperator />
        {coinsSummary?.expired ? (
          <Stack className="flex-1 items-center self-center">
            <B2 className="text-grays-80">
              {i18n.t('coinsLedger.homeScreen.expired')}
            </B2>
            <SH1 style={styles.expiredTextColor}>
              {currencyFormatConvertorRoundDown(
                coinsSummary?.expired?.toFixed(0) || '00'
              )}
            </SH1>
          </Stack>
        ) : (
          <></>
        )}
        {coinsSummary?.expired ? <Seperator /> : <></>}
        <Stack className="flex-1 items-center self-center">
          <B2 className="text-grays-80">
            {i18n.t('coinsLedger.homeScreen.balance')}
          </B2>
          <SH1 style={styles.balanceTextColor}>
            {currencyFormatConvertorRoundDown(
              coinsSummary?.balance.toFixed(0) || '00'
            )}
          </SH1>
        </Stack>
      </XStack>
    </Stack>
  )
}

const styles = StyleSheet.create({
  cardContainer: { marginTop: -85 },
  cardSubContainer: {
    backgroundColor: '#FFF0CF',
  },
  zetCoinIcon: { marginTop: -40 },
  redeemedTextColor: { color: '#D68000' },
  expiredTextColor: { color: colors.error[150] },
  balanceTextColor: { color: colors.success[150] },
})
export { CoinsLedgerSpotlight }
